<ion-content>
  <div class="container" *ngIf="me">

    <div class="author">
      <div class="image" [image-loader]="me.profileImage"></div>
      <div class="details">
        <div class="name">{{me.fullname}}</div>
        <div class="publish-date">{{me.email}}</div>
      </div>
      <div class="option">
        <ion-button fill="clear" color="medium" size="small" (click)="closeModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </div>
    </div>

    <div class="wrapper">

      <div class="input-wrapper light fill" *ngIf="more">
        <div class="row">
          <textarea placeholder="{{'FeedModule.Add.title-label' | translate}}" elastic-textarea name="title"
            #title="ngModel" [(ngModel)]="feed.title"></textarea>
        </div>
      </div>

      <div class="input-wrapper light fill" *ngIf="more">
        <div class="row">
          <textarea placeholder="{{'FeedModule.Add.subtitle-label' | translate}}" elastic-textarea name="subtitle"
            #subtitle="ngModel" [(ngModel)]="feed.subtitle"></textarea>
        </div>
      </div>

      <div class="input-wrapper light fill">
        <div class="row">
          <div class="prefix"><span class="lnr lnr-bubble"></span></div>
          <textarea placeholder="{{'FeedModule.Add.content-label' | translate}}" elastic-textarea name="content"
            #content="ngModel" [(ngModel)]="feed.content"></textarea>
        </div>
      </div>

      <!-- image section -->
      <input #fileUpload type="file" id="file-upload" accept="image/*" style="display:none" (change)="uploadFile($event)">
      <div class="image-content">
        <div class="image-item" [image-loader]="item" *ngFor="let item of feedImages | slice: 0: 3"></div>
        <div class="image-item" *ngIf="feedImages.length > 3">
          <ion-icon name="add"></ion-icon>
        </div>
      </div>

      <div class="actions mt10">

<!--        <div class="start">-->
<!--          <ion-button fill="clear" *ngFor="let item of feedOptions" (click)="item.click()">-->
<!--            <ion-icon src="assets/icon/{{item.icon}}.svg"></ion-icon>-->
<!--          </ion-button>-->
<!--        </div>-->
        <div class="end">
          <ion-button size="small" shape="round" (click)="save()"> {{'FeedModule.Add.post-button' | translate}}
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<app-spinner *ngIf="loading"></app-spinner>
